module.exports = __webpack_public_path__ + "img/dark-mode-logo2.e3182d19.svg";